export const HOME_PAGE_CATEGORIES = ['montreal', 'toronto', 'landlord', 'tenant']

export const NAV_CATEGORIES = [...HOME_PAGE_CATEGORIES, 'newcomers', 'apartment-living', 'roommates', 'lifehacks']
